var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotonNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 32",
    style: {
      enableBackground: "new 0 0 181 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F59C14;}\r\n\t.st1{fill:#14499A;}\r\n\t.st2{fill:#73B62B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_127_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M70,14.6l0.1,5.6h-3L55.3,4.9h-0.2l0,9.1l0,6.3h-2.6l0.1-5.7L52.6,1h3l11.8,15.4h0.2l0-15.3 L70.2,1L70,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M87.2,8.1C88.4,9.3,89,11,89,13.2c0,2.3-0.6,4.1-1.9,5.4c-1.3,1.3-3.1,1.9-5.5,1.9 c-2.2,0-4-0.6-5.2-1.8c-1.2-1.2-1.8-2.9-1.8-5.1c0-2.3,0.6-4.1,1.9-5.4c1.3-1.3,3.1-1.9,5.5-1.9C84.3,6.3,86,6.9,87.2,8.1z  M78.5,9.2c-0.8,0.9-1.2,2.1-1.2,3.8c0,1.9,0.4,3.4,1.2,4.3c0.8,1,1.9,1.4,3.4,1.4c1.5,0,2.6-0.4,3.4-1.3c0.8-0.8,1.2-2.1,1.2-3.8 c0-1.9-0.4-3.3-1.2-4.3c-0.8-1-1.9-1.5-3.4-1.5C80.4,8,79.3,8.4,78.5,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M101.5,17.8l0.3,0.2l-0.3,1.6c-1.3,0.5-2.5,0.8-3.6,0.9c-1.4-0.2-2.3-0.6-2.9-1.3 c-0.6-0.6-0.9-1.5-0.9-2.7l0.1-2.1l0-6.2H92L91.8,8L92,6.5h2.2V4.3l2.5-0.9l0.3,0.2l-0.1,2.9h4.8l0.1,0.2l-0.2,1.4h-4.8l-0.2,8.1 c0,0.8,0.1,1.4,0.5,1.7c0.4,0.3,0.9,0.5,1.7,0.5C99.7,18.4,100.5,18.2,101.5,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M108.1,0.7c0.3,0.2,0.4,0.6,0.4,1c0,0.4-0.1,0.8-0.4,1c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.7-0.4,1.2-0.4C107.5,0.4,107.8,0.5,108.1,0.7z  M105.7,14.4l-0.1-7.8l2.7-0.2l-0.1,7.8l0.1,6h-2.8L105.7,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M122.6,6.5c0.8,0.1,1.5,0.3,2.1,0.6l-0.5,2.1l-0.3,0.1c-1.2-0.7-2.5-1-3.7-1 c-1.4,0-2.5,0.5-3.3,1.4c-0.8,0.9-1.2,2.2-1.2,3.8c0,1.6,0.4,2.9,1.2,3.8c0.8,0.9,1.9,1.4,3.4,1.4c0.6,0,1.3-0.1,2-0.3 c0.7-0.2,1.4-0.4,2-0.8l0.3,0.2l-0.3,2c-1.4,0.5-2.9,0.8-4.3,0.8c-2.2,0-3.9-0.6-5.1-1.9c-1.2-1.2-1.8-3-1.8-5.1 c0-2.2,0.6-4,1.9-5.3c1.3-1.3,3.1-1.9,5.3-1.9C121,6.3,121.8,6.4,122.6,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M131.1,0.7c0.3,0.2,0.4,0.6,0.4,1c0,0.4-0.1,0.8-0.4,1c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.7-0.4,1.2-0.4C130.5,0.4,130.8,0.5,131.1,0.7z  M128.7,14.4l-0.1-7.8l2.7-0.2l-0.1,7.8l0.1,6h-2.8L128.7,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st0",
    d: "M146.5,7.2c0.9,0.6,1.3,1.5,1.3,2.6c0,0.3-0.1,1.6-0.2,3.7c-0.1,2.1-0.2,3.4-0.2,3.7 c0,0.4,0.1,0.7,0.2,0.9s0.5,0.3,0.9,0.3c0.4,0,0.8-0.1,1.2-0.2l0.3,0.2l-0.3,1.3c-0.7,0.3-1.4,0.5-2,0.6c-0.7-0.1-1.3-0.3-1.8-0.7 c-0.4-0.4-0.7-0.9-0.7-1.6h-0.2c-1.3,1.1-2.5,1.9-3.8,2.2c-1.6,0-2.8-0.3-3.7-1s-1.3-1.6-1.3-2.7c0-0.9,0.3-1.6,0.8-2.1 c0.6-0.5,1.4-0.9,2.5-1.1l5.8-1.1l0-2c0-0.8-0.2-1.4-0.7-1.8C144,8.2,143.3,8,142.4,8c-0.8,0-1.6,0.2-2.4,0.5 c-0.8,0.3-1.7,0.8-2.6,1.5l-0.3-0.1l-0.4-1.7c2-1.2,4-1.9,6.1-1.9C144.4,6.3,145.6,6.6,146.5,7.2z M140,14.9 c-0.5,0.1-0.8,0.3-1,0.5c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.7,0.2,1.2,0.7,1.5c0.4,0.4,1,0.6,1.8,0.6c1.3,0,2.6-0.7,4-2.1l0.1-2.5 L140,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M162.6,7l-0.4,2L161.8,9c-1.2-0.7-2.3-1-3.4-1c-0.8,0-1.5,0.2-2,0.6c-0.5,0.4-0.7,0.8-0.7,1.4 s0.3,1,0.8,1.3c0.5,0.3,1.3,0.7,2.4,1.1c0.9,0.4,1.7,0.7,2.2,1s1,0.7,1.4,1.2c0.4,0.5,0.6,1.1,0.6,1.8c0,0.7-0.2,1.4-0.7,2.1 c-0.5,0.6-1.1,1.2-2,1.5c-0.9,0.4-1.9,0.6-3.1,0.6c-1.7,0-3.2-0.3-4.7-1l0.4-2l0.3-0.2c0.7,0.5,1.4,0.8,2.2,1.1 c0.8,0.3,1.5,0.4,2.2,0.4c0.9,0,1.6-0.2,2.1-0.6s0.8-0.9,0.8-1.5c0-0.5-0.3-1-0.8-1.3c-0.5-0.3-1.3-0.7-2.4-1.1 c-0.9-0.4-1.7-0.7-2.2-1c-0.6-0.3-1.1-0.7-1.5-1.2c-0.4-0.5-0.6-1.1-0.6-1.9c0-1.2,0.5-2.1,1.5-2.8c1-0.7,2.4-1.1,4.1-1.1 C160,6.3,161.3,6.5,162.6,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_155_",
    x: 0.5,
    y: 6.8,
    className: "st1",
    width: 32.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_141_",
    x: 0.5,
    y: 17.7,
    className: "st2",
    width: 32.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_124_",
    x: 0.5,
    y: 28.6,
    className: "st0",
    width: 180,
    height: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonNews);
export default __webpack_public_path__ + "static/media/botonNews.0cc626b0c9ae0bb05c0645835acbcb40.svg";
export { ForwardRef as ReactComponent };